<template>
  <div class="bridal-item-group-menu" :class="{ 'is-open': isOpen }">
    <div v-if="isOpen" class="bridal-item-overlay" @click="close">
      <div class="bridal-item-accordion-menu">
        <ul>
          <li class="bridal-item-accordion-box"
            v-for="group in groupList"
            :key="group.groupName"
            @click="close"
          >
            <router-link
              :to="$wcRouter.path({
                name: 'bridal-item.show',
                params: { groupId: group.groupId }
              })"
            >
              {{ $domUtils.decode(group.groupName) }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="bridal-item-flex-box-parent">
      <div class="bridal-item-flex-box">
        <div class="bridal-item-flex-items">
          <router-link :to="$wcRouter.path({ name: 'bridal-item.index' })">
            <i @click="close" class="fas fa-home"></i>
          </router-link>
        </div>
        <div class="bridal-item-flex-items">
          <router-link :to="$wcRouter.path({ name: 'collage.index' })">
            <i @click="close" class="fas fa-image"></i>
          </router-link>
        </div>
        <div class="bridal-item-flex-items">
          <router-link :to="$wcRouter.path({ name: 'simulation.index' })">
            <i @click="close" class="fas fa-calculator"></i>
          </router-link>
        </div>
        <div class="bridal-item-flex-items">
          <router-link :to="$wcRouter.path({ name: 'bridal-item.favorite' })">
            <i @click="close" class="far fa-bookmark"></i>
          </router-link>
        </div>
        <div class="bridal-item-flex-items">
          <i @click="open" class="fas fa-bars bridal-item-fa-bars"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bridalItemApi from '@/api/bridal-item'
import { renderError } from '@/utils/error'

export default {
  data() {
    return {
      groupList: [],
    }
  },
  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    },
    isOpen() {
      return this.$store.state.navbar.isBridalItemGroupMenuOpen
    },
  },
  methods: {
    async fetchGroup() {
      let response = null
      try {
        response = await bridalItemApi.getGroup(
          this.businessId,
        )
      } catch (err) {
        renderError(err)
      }
      for (let i = 0; i < response.length; i++) {
          this.groupList.push({
            groupName: response[i].bridal_item_group_name,
            groupId: response[i].bridal_item_group_id,
          })
      }
    },
    open() {
      this.$store.commit('navbar/toggleBridalItemGroupMenu')
    },
    close() {
      if (this.isOpen === true) {
        this.$store.commit('navbar/toggleBridalItemGroupMenu')
      } else {
        if (this.$store.state.navbar.isGlobalMenuOpen) {
          this.$store.commit('navbar/toggleGlobalMenu')
        }
      }
    }
  },
  created() {
    this.fetchGroup()
  },
}
</script>
